import React, { Component } from 'react'
import Sidebar from './Sidebar';
import store from '../../../store';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import { Link } from 'react-router'
import { getActiveJobMela, getFilteredActiveJobMela, get_User_District, get_selected_User_District } from '../../../actions/accountAction'
import { getUserProfileInterest, addUserProfileInterest } from '../../../actions/jobseekerAction'
import SimpleReactValidator from 'simple-react-validator';


class JobResume extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

        store.dispatch(get_selected_User_District());
    }
    componentDidMount() {
        document.title = this.props.t('interest.title', { param: 'react' })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

    }

    async handleUserInput(e) {
        const name = e.target.name;
        let value = e.target.value;
        let type = e.target.type;
        let key = e.target.key;

        if (type === "text") {
            let regex = /^[A-Za-z0-9 ]+$/;
            if (!regex.test(value) && value) {
                return false;
            }
        }


        this.setState({ [name]: value, submitStatus: false });

        store.dispatch(getFilteredActiveJobMela(value))

    }

    createDistoption = () => {
        let Mainprops = this.props;
        let Distoption = [];
        if (Mainprops.actionReducer.selectedDistricts.length > 0) {
            Mainprops.actionReducer.selectedDistricts.map(function (data) {
                if (data.state_name === "Punjab") {
                    data.dist.map(function (distdata, distindex) {
                        Distoption.push(
                            <option key={distindex} value={distdata.id}>
                                {distdata.name}
                            </option>
                        );
                        return Distoption;
                    });
                }
                return Distoption;
            });
        }
        return Distoption;
    };



    render() {
        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }
        const Mainprops = this.props


        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={Mainprops.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="clearfix"></div>
                            <div>
                                <div className="tab-content">
                                    <div id="home" className=" tab-pane active">
                                        <section className="login-form mt-0">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-12 col-lg-12 mx-auto p-0">
                                                        <div className="panel-heading">
                                                            <h6 className="mb-0">{this.props.t('interest.title', { param: 'react' })}</h6>
                                                        </div>

                                                        <div className="row district-form-container pt-2">
                                                            <div className="col-sm-12 text-left">
                                                                <label>
                                                                    {/* {this.props.t("register_user.district", { param: "react" })} */}
                                                                    Select District
                                                                    {/* <span className="errorclr ml-2">
                                                                        *
                                                                    </span> */}
                                                                </label>
                                                                <select
                                                                    className="form-control "
                                                                    aria-label="Select District"
                                                                    id="district_id"
                                                                    onChange={(event) => this.handleUserInput(event)}
                                                                    name="district_id"
                                                                >
                                                                    <option value={""}>
                                                                        {this.props.t("profileDetails.selectDistrict", {
                                                                            param: "react",
                                                                        })}
                                                                    </option>
                                                                    {this.createDistoption()}
                                                                </select>

                                                            </div>
                                                        </div>

                                                        <div class="panel-body">
                                                            <div class="table-responsive">
                                                                <table class="table table-hover table-striped">
                                                                    {this.props.actionReducer.activeJobMela && this.props.actionReducer.activeJobMela.length > 0 ? <>  <thead>
                                                                        <tr>
                                                                            <th>S.No</th>
                                                                            <th> Mela Name</th>
                                                                            <th>District</th>
                                                                            <th>Start Date</th>
                                                                            <th>End Date</th>
                                                                            {/* <th>Vacancies</th> */}
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                        <tbody>
                                                                            {this.props.actionReducer.activeJobMela.map((mela, index) =>
                                                                                <tr>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{mela.jobMela}</td>
                                                                                    <td>{mela.mela_district_name}</td>

                                                                                    <td>{mela.mela_start_date_time}</td>
                                                                                    <td>{mela.mela_end_date_time}</td>
                                                                                    {/* <td>{mela.provider_count}</td> */}
                                                                                    <td> <button
                                                                                        aria-label="Go to Job Fair"
                                                                                        type='button' onClick={() => {
                                                                                            this.props.router.push(`/jobfair?mela-id=${mela.id}`)
                                                                                        }} className='btn btn-primary2 py-1 px-2'>view</button> </td>
                                                                                </tr>)}


                                                                            {/* <tr>
                                                                            <td>2</td>
                                                                            <td>Private</td>
                                                                            <td> <button type='button' className='btn btn-primary2 py-1 px-2'>Apply</button> </td>
                                                                        </tr> */}
                                                                            {/* <tr>
                                                                            <td colspan="3" >
                                                                                <h5>No Records Found</h5>
                                                                            </td>
                                                                        </tr> */}
                                                                        </tbody></> : <div
                                                                            className="job-not-found">
                                                                        <h3>{this.props.t('JobPost.notFound', { param: 'react' })}</h3>
                                                                    </div>}


                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = store => {
    return store;
};

export default connect(mapStateToProps)(translate(JobResume));